import { Node, mergeAttributes } from "@tiptap/core";

export const EMBED_DEFAULT_WIDTH = 720;
export const EMBED_DEFAULT_HEIGHT = 440;

export type EmbedNodeAttrs = {
  url: string;
  width: number;
  height: number;
  alignment: string;
};

export const Embed = Node.create({
  name: "embed",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      url: {
        default: null,
      },
      width: {
        default: EMBED_DEFAULT_WIDTH,
      },
      height: {
        default: EMBED_DEFAULT_HEIGHT,
      },
      alignment: {
        default: "left",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "embed-block",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["embed-block", mergeAttributes(HTMLAttributes)];
  },
});
